(function () {
  function isHomePath(pathname) {
    return pathname === '/' || pathname === '';
  }

  function scrollHomeToTop() {
    if (window.location.hash) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  function pinHomeScroll() {
    if (!document.body.classList.contains('template-index')) return;
    scrollHomeToTop();
    requestAnimationFrame(scrollHomeToTop);
  }

  if (document.body.classList.contains('template-index') && 'scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  pinHomeScroll();
  window.addEventListener('pageshow', pinHomeScroll);
  window.addEventListener('load', pinHomeScroll);

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('.header__heading-link');
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (!isHomePath(url.pathname)) return;

      if (isHomePath(window.location.pathname)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        pinHomeScroll();
      }
    },
    true
  );
})();
